/* global common, StickyMenuNavigationDesktop, StickyMenuNavigationMobile */

import {
  byUserInteraction,
  byWindowAction,
  getBreakpointMinWidth,
  isElementOnScreen,
  sendAmplitudeEvent,
} from '@html/_common/utils';

export default function AOStickyMenu() {
  this.common = {};
  if (typeof byUserInteraction !== 'undefined') {
    this.common = {
      byUserInteraction,
      byWindowAction,
      getBreakpointMinWidth,
      isElementOnScreen,
      sendAmplitudeEvent,
      func: { isElementOnScreen },
    };
  } else {
    this.common = common;
  }
  const navigation = {
    stickyNavigation: false,
  };

  const SELECTOR_MENU = '.js-ao-sticky-menu';
  const MOBILE_WIDTH = this.common.getBreakpointMinWidth('m2') - 1;
  const CLASS_MENU_STICKY = 'ao-sticky-menu__wrapper--sticky';
  const SELECTOR_STICKY_MENU_ITEM = '.js-ao-sticky-menu__list-item';
  const SELECTOR_STICKY_MENU = '.js-ao-sticky-menu__wrapper';
  const SELECTOR_STICKY_CTA = '.js-ao-sticky-cta';
  const SELECTOR_TOP_CTA = '.js-ao-sticky-menu__cta-button';
  const HID_CLASS = 'ao-sticky-cta--hidden';

  let $menu = null;
  let $menuSection = null;
  let menuOffset = null;
  let $window = null;

  const isInMobileWidth = (width) => width <= MOBILE_WIDTH;

  const getDeviceType = (width) => {
    if (isInMobileWidth(width)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const isMobileDevice = () => getDeviceType($(window).width()) === 'mobile';
  const isDesktopDevice = () => getDeviceType($(window).width()) === 'desktop';
  const goToPage = (link) => {
    window.location.href = link.replaceAll('@', '/');
  };

  const syncChatStickyCTAPositions = () => {
    $(document).on('stickyCTA:visibilityChange', (_, isActive) => {
      if (isActive && $('.live-chat-tr-placeholder').length) {
        $('.live-chat-tr-placeholder').css(
          'bottom',
          '90px',
        );
        return;
      }
      if ($('.live-chat-tr-placeholder').length) {
        $('.live-chat-tr-placeholder').removeAttr('style');
      }
    });
  };

  const initiateStickyNavigationMenuDesktop = () => {
    if (typeof byUserInteraction !== 'undefined') {
      import(/* webpackChunkName: "StickyMenuDesktop" */'@atomic/organisms/_common/navigation/sticky-menu/desktop/script').then((module) => {
        const StickyMenuNavigationDesktop = module.default;
        if (!navigation.stickyNavigation) {
          navigation.stickyNavigation = new StickyMenuNavigationDesktop();
          navigation.stickyNavigation.initiate();
        }
      });
    } else {
      this.common.loadJs(this.common.scriptUrl.stickyNavigationDesktop, () => {
        navigation.stickyNavigation = new StickyMenuNavigationDesktop();
        navigation.stickyNavigation.initiate();
      });
    }
  };

  const initiateStickyNavigationMenuMobile = (event, callback) => {
    if (!navigation.stickyNavigation) {
      if (typeof byUserInteraction !== 'undefined') {
        import(/* webpackChunkName: "StickyMenuMobile" */'@atomic/organisms/_common/navigation/sticky-menu/mobile/script').then((module) => {
          const StickyMenuNavigationMobile = module.default;
          navigation.stickyNavigation = new StickyMenuNavigationMobile();
          navigation.stickyNavigation.initiate(event);
        });
      } else {
        this.common.loadJs(this.common.scriptUrl.stickyNavigationMobile, () => {
          navigation.stickyNavigation = new StickyMenuNavigationMobile();
          navigation.stickyNavigation.initiate(event);
        });
      }
    }
    if (navigation.stickyNavigation && callback) {
      navigation.stickyNavigation[callback](event);
    }
  };

  const stickyNavigationInitiate = () => {
    // For Desktop
    if (isDesktopDevice()) {
      this.common.byUserInteraction('load-sticky-navigation-menu-desktop', initiateStickyNavigationMenuDesktop);
    } else {
      $('body').on('click', SELECTOR_STICKY_MENU_ITEM, (e) => {
        e.preventDefault();
        initiateStickyNavigationMenuMobile(e, 'handleMenuItemClick');
      });
    }
  };

  const handleMenuSticking = () => {
    if (menuOffset <= $window.scrollTop() && !$menu.hasClass(CLASS_MENU_STICKY)) {
      const menuHeight = $menu.height();

      $menu.toggleClass(CLASS_MENU_STICKY, true);
      $menuSection.css('height', `${menuHeight}px`);
    } else if (menuOffset > $window.scrollTop() && $menu.hasClass(CLASS_MENU_STICKY) && $('body').prop('style').overflow === '') {
      $menu.toggleClass(CLASS_MENU_STICKY, false);
      $menuSection.css('height', '');
    }

    const $stickyCTA = isMobileDevice() ? $(SELECTOR_STICKY_CTA) : $(SELECTOR_TOP_CTA);
    const hiddenClass = isMobileDevice() ? HID_CLASS : 'hid';

    let isTriggerVisible = false;
    const stickyOutOfBoundsTriggerElement = document.querySelector(SELECTOR_STICKY_CTA).dataset.trigger;
    if (stickyOutOfBoundsTriggerElement) {
      const stickyOutOfBoundsTriggerClass = `.${stickyOutOfBoundsTriggerElement}`;
      if (this.common.func.isElementOnScreen(stickyOutOfBoundsTriggerClass)) {
        isTriggerVisible = true;
      }
    } else {
      isTriggerVisible = $(window)
        .scrollTop() < 500;
    }

    if (isTriggerVisible) {
      if ($stickyCTA.hasClass(hiddenClass)) return;
      $stickyCTA.addClass(hiddenClass);
      if (isMobileDevice()) {
        $(document).trigger('stickyCTA:visibilityChange', false);
      }
      return;
    }

    if (!$stickyCTA.hasClass(hiddenClass)) return;
    $stickyCTA.removeClass(hiddenClass);
    if (isMobileDevice()) {
      $(document).trigger('stickyCTA:visibilityChange', true);
    }
  };

  this.initiate = () => {
    $menu = $(SELECTOR_STICKY_MENU);
    if (!$menu.length) {
      return;
    }
    stickyNavigationInitiate();

    $menuSection = $menu.parent();
    menuOffset = $menu.offset().top;
    $window = $(window);

    syncChatStickyCTAPositions();

    handleMenuSticking();
    this.common.byWindowAction(['scroll'], handleMenuSticking);
    $(document).on('ready', () => {
      handleMenuSticking();
    });

    const ctaButton = document.querySelector('.js-ao-sticky-menu__cta-button');
    const ctaButtonBottom = document.querySelector('.js-ao-sticky-cta__button');
    const overviewButton = document.querySelector('.js-ao-sticky-menu__list-item-overview');
    const eventName = $(SELECTOR_MENU).data('event-name');

    if (ctaButton) {
      ctaButton.addEventListener('click', () => {
        const title = $('.js-ao-sticky-menu__cta-button').data('title');
        this.common.sendAmplitudeEvent({
          ampEventName: eventName,
          navigation_menu_option: title,
          navigation_menu_section: 'Main CTA',
        });
        goToPage(ctaButton.dataset.link);
      });
    }

    if (ctaButtonBottom) {
      ctaButtonBottom.addEventListener('click', () => {
        const title = $('.js-ao-sticky-cta__button').data('title');
        this.common.sendAmplitudeEvent({
          ampEventName: eventName,
          navigation_menu_option: title,
          navigation_menu_section: 'Main CTA',
        });
        goToPage(ctaButtonBottom.dataset.link);
      });
    }

    if (overviewButton) {
      overviewButton.addEventListener('click', () => {
        const title = $('.js-ao-sticky-menu__list-item-overview').data('title');
        this.common.sendAmplitudeEvent({
          ampEventName: eventName,
          navigation_menu_option: title,
          navigation_menu_section: 'Overview',
        });
      });
    }
  };
}
